import { useNavigate } from 'react-router-dom';

import { ContentLayout } from 'layouts/ContentLayout/ContentLayout';
import PageTitle from 'components/PageTitle';
import RequestsTable from './RequestsTable';
import { GraniteButton } from 'components/V2/Button/GraniteButton';

const SupportRequestIndex = () => {
  const navigate = useNavigate();

  return (
    <ContentLayout className="min-h-screen !justify-start gap-6">
      <div className="mb-2 flex flex-col justify-between gap-2 md:flex-row md:items-center">
        <PageTitle title="Support request index" />
        <GraniteButton
          onClick={() => navigate('new')}
          size="large"
          className="w-full md:w-max"
        >
          New request
        </GraniteButton>
      </div>
      <RequestsTable />
    </ContentLayout>
  );
};

export default SupportRequestIndex;
